import React from 'react';
import { navigateTo } from "gatsby-link";

import Selector from '../../styled-components/Selector';
import Selected from '../../styled-components/Selected';
import MenuItems from '../../styled-components/MenuItems';
import MenuItem from '../../styled-components/MenuItem';
import world from '../../img/world.svg';
import arrowDown from '../../img/arrow-down.svg';

class Select extends React.Component {
  constructor() {
    super()
    this.state = { open: false }
    this.handleClick = this.handleClick.bind(this);
  }
  componentDidMount() {
    document.addEventListener('mousedown', this.handleClick);
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick);
  }
  handleClick(e) {
    if (!this.node.contains(e.target)) {
      this.setState({ open: false });
    }
  }
  render() {
    const goTo = path => {
      this.setState({ open: false });
      navigateTo(path);
    }
    const handleSelect = e => {
      this.setState({ open: !this.state.open });
    }
    const items = this.props.items ? this.props.items.map((item, i) => {
      if(item.path !== '/socialblade') {
        return (
          <MenuItem key={i} onClick={ () => goTo(item.path) }>{ item.language }</MenuItem>
        )
      }
    }) : null;
    return (
      <div ref={node => this.node = node}>
        <Selector marginBottom={this.props.marginBottom}>
          <Selected onClick={e => handleSelect(e)}>
            <img src={world} /> <p>{this.props.language}</p> <img src={arrowDown} />
          </Selected>
          <MenuItems open={this.state.open} bottom={this.props.bottom}>
            {items}
          </MenuItems>
        </Selector>
      </div>
    );
  }
}

export default Select;



// WEBPACK FOOTER //
// ./src/components/LanguageSelector/index.js